/**
 * Extract the numeric id from a react-select option-shaped field ({value, label})
 * stored on a form data object. Returns the option's value if present, else null.
 */
export const extractOptionValue = (data, key) => {
  const option = data?.[key];
  if (option && option.value !== undefined && option.value !== null) {
    return option.value;
  }
  return null;
};

/**
 * Normalise a referee id field on a form data object in place. If the referee
 * type matches `expectedTypeId`, the field is replaced with the option's
 * numeric value; otherwise it's nulled out.
 */
export const assignRefereeId = (
  data,
  refereeIdKey,
  refereeTypeIdKey,
  expectedTypeId,
) => {
  data[refereeIdKey] =
    data?.[refereeIdKey]?.value && data[refereeTypeIdKey] === expectedTypeId
      ? data[refereeIdKey].value
      : null;
};
